import React from 'react';
import { TextValidator } from 'react-material-ui-form-validator';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { Grid } from '@mui/material';

interface SectionNameInputProps {
    sectionData: RecipeSection;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const SectionNameInput = ({ sectionData, onChange }: SectionNameInputProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    return (
        <Grid item xs={12} sx={{ marginTop: '10px' }}>
            {formData.readOnly ? (
                <div>
                    {i18n('name')}: {sectionData.name}
                </div>
            ) : (
                <TextValidator
                    fullWidth
                    label={i18n('name')}
                    name="name"
                    variant="outlined"
                    onChange={onChange}
                    value={sectionData.name}
                    validators={['required']}
                    errorMessages={[i18n('this_field_is_required')]}
                />
            )}
        </Grid>
    );
};

export default SectionNameInput;
